module.exports = __webpack_public_path__ + "a1cb92303825a6e92d38f04d4c5968ab.svg";